import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate } from "@/lib/api";
import { Wallet } from "lucide-react";

export default function StaffPayslip() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/payroll/my-payslip").then((r) => setData(r.data)); }, []);

  return (
    <div className="p-4 space-y-3" data-testid="staff-payslip">
      <h2 className="font-serif text-2xl font-bold flex items-center gap-2"><Wallet className="w-6 h-6 text-emerald-800" />Phiếu lương</h2>

      {data.map((p) => (
        <div key={p.id} className="bg-white border border-stone-200 rounded-sm overflow-hidden">
          <div className="bg-emerald-900 text-white px-4 py-3">
            <div className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-bold">Kỳ {p.period_code}</div>
            <div className="text-xs">{fmtDate(p.from_date)} → {fmtDate(p.to_date)}</div>
            <div className="font-serif text-3xl font-bold mt-2">{fmtMoney(p.net_pay)}</div>
            <div className="text-[10px] uppercase tracking-wider text-stone-300 mt-0.5">Thực lĩnh</div>
          </div>
          <div className="p-4 space-y-2 text-sm">
            <Row l="Lương cơ bản" v={fmtMoney(p.base_salary)} />
            <Row l={`KPI Score (${Number(p.kpi_score).toFixed(1)}%)`} v={fmtMoney(p.kpi_bonus)} accent="emerald" />
            <Row l={`Bonus xếp hạng ${p.abc_rank || "—"}`} v={fmtMoney(p.abc_bonus)} accent="amber" />
            {Number(p.deductions) > 0 && <Row l="Khấu trừ" v={`-${fmtMoney(p.deductions)}`} accent="red" />}
            <div className="border-t border-stone-200 pt-2 flex justify-between font-bold">
              <span>Tổng thực lĩnh</span><span className="font-mono">{fmtMoney(p.net_pay)}</span>
            </div>
            <div className="text-[10px] text-stone-500 mt-2">⏱ Số phút làm: <span className="font-mono">{p.worked_minutes}</span></div>
          </div>
        </div>
      ))}

      {data.length === 0 && (
        <div className="bg-white border border-stone-200 rounded-sm p-10 text-center">
          <Wallet className="w-12 h-12 mx-auto text-stone-300 mb-3" />
          <p className="text-stone-500 text-sm">Chưa có phiếu lương nào.<br />Vui lòng đợi HR tính lương kỳ này.</p>
        </div>
      )}
    </div>
  );
}

function Row({ l, v, accent }) {
  const color = accent === "emerald" ? "text-emerald-800" : accent === "amber" ? "text-amber-800" : accent === "red" ? "text-red-700" : "";
  return (
    <div className="flex justify-between">
      <span className="text-stone-600">{l}</span>
      <span className={`font-mono font-semibold ${color}`}>{v}</span>
    </div>
  );
}
